import styled from 'styled-components';

import { flexCenter, flexStart, scrollCss } from '../../style/reusableStyle';

export const MessageContainerStyled = styled.div`
  display: flex;
  align-items: flex-start;
`;
export const UserListContainer = styled.div`
  position: relative;
  width: 325px;
  border-right: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.white};
  padding: 0px 20px 40px;
  max-height: calc(100vh - 60px);
  overflow: auto;
  & .search-user {
    margin-top: 40px;
    -webkit-position: sticky;
    position: sticky;
    top: 10px;
    margin-bottom: 30px;
    background: ${({ theme }) => theme.colors.white} !important;
    z-index: ${({ theme }) => theme.zIndices.sticky};
  }
  ${scrollCss};

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const RoleWiseUserGroupContainer = styled.div`
  margin-bottom: 20px;
  & .group-title-wrapper {
    margin-bottom: 20px;
  }

  & .users-container {
  }
`;

export const IndividualUserWrapper = styled.div`
  position: relative;
  padding: 3px 20px 0px 3px;
  margin: 0px 0px 16px 0px;
  display: flex;
  align-items: flex-start;
  gap: 30px;
  cursor: pointer;
  & .avatar {
  }
  & .user-info {
  }

  &:hover {
    background: ${({ theme }) => theme.colors.disable};
  }

  & .user-info-wrapper {
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }

  & .message-status-wrapper {
    content: '';
    position: absolute;
    top: 3px;
    right: 3px;
    width: 15px;
  }

  & .unread-msg {
    height: 11px;
    width: 11px;
    border-radius: 50%;
  }

  & .unread-msg.technician {
    background: ${({ theme }) => theme.colors.technician.strong};
  }
  & .unread-msg.printer {
    background: ${({ theme }) => theme.colors.printer.strong};
  }
  & .unread-msg.draftman {
    background: ${({ theme }) => theme.colors.draftman.strong};
  }
  & .unread-msg.fireTeam {
    background: ${({ theme }) => theme.colors.fireTeam.strong};
  }

  & .sent-msg {
    width: 14px;
    height: 14px;
    ${flexCenter(0)};
    border-radius: 50%;
    border: 1px solid #00c67f;
  }
  & .sent-msg.technician {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.technician.strong};
      }
    }
    border-color: ${({ theme }) => theme.colors.technician.strong};
  }
  & .sent-msg.printer {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.printer.strong};
      }
    }
    border-color: ${({ theme }) => theme.colors.printer.strong};
  }
  & .sent-msg.draftman {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.draftman.strong};
      }
    }
    border-color: ${({ theme }) => theme.colors.draftman.strong};
  }
  & .sent-msg.fireTeam {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.fireTeam.strong};
      }
    }
    border-color: ${({ theme }) => theme.colors.fireTeam.strong};
  }
`;

export const ActiveMessagingContainer = styled.div`
  flex: 1;
  position: relative;
  max-height: calc(100vh - 60px);
  overflow: auto;
  ${scrollCss};

  & .chat-header-container {
    -webkit-position: sticky;
    position: sticky;
    top: 0px;
    z-index: ${({ theme }) => theme.zIndices.sticky};
    padding: 14px 20px;
    background: ${({ theme }) => theme.colors.lightBackground};
    ${flexStart};
    gap: 24px;
  }
  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const ConversationContainer = styled.div`
  padding: 10px 30px;
  & .divider-text {
    background: ${({ theme }) => theme.colors.gray99};
  }
`;

export const IndividualMessage = styled.div<{ $isMyMessage: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: ${({ $isMyMessage }) =>
    $isMyMessage ? 'row-reverse' : 'row'};

  gap: 20px;

  & .message-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    flex-direction: column;

    & .message {
      border-radius: 5px;
      background: ${({ theme }) => theme.colors.lightBackground};
      max-width: 300px;
      padding: 15px 20px;
      white-space: break-spaces;
    }
    & .time {
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }

  margin-bottom: 30px;
`;

export const AvatarOnlineWrapper = styled.div<{ $isOnline?: boolean }>`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 1.5px;
    right: 1.5px;
    height: 11px;
    width: 11px;
    background: ${({ theme, $isOnline }) =>
    $isOnline ? theme.colors.green.strong : theme.colors.black};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.white};
  }
`;

export const MessageInputContainer = styled.div`
  -webkit-position: sticky;
  position: sticky;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 0px 20px 10px;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  & .input-wrapper {
    width: 100%;
    ${flexStart};
    gap: 14px;
    padding: 10px 0px;

    & .message-input {
      flex: 1;
    }

    & .icon-btn {
      height: 24px;
      width: 24px;
      cursor: pointer;
      flex: 1 0 auto;
    }
  }
`;
